"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionsTableConf = void 0;
var date_fns_1 = require("date-fns");
var constants_1 = require("containers/TableMaker/constants");
var formatters_1 = require("utils/formatters");
var Attachments_1 = __importDefault(require("./Attachments"));
var MD = constants_1.CellSize.MD, SM = constants_1.CellSize.SM, XS = constants_1.CellSize.XS;
exports.transactionsTableConf = {
    headersMap: { currency: 'Cur.', attachmentUrls: '' },
    extractors: {
        amount: function (t) { return t.subTotal || t.total; },
        source: function (t) { var _a; return (0, formatters_1.camelToProper)((_a = t.source) === null || _a === void 0 ? void 0 : _a.replace(/Api$/, '')); },
    },
    cells: [
        { cell: { width: SM + XS }, field: 'date', renderField: function (d) { return d && (0, date_fns_1.format)(d.toDate(), 'yyyy-MM-dd'); } },
        { cell: { width: MD }, truncate: {}, field: 'contactName' },
        { cell: { width: MD }, truncate: {}, field: 'reference' },
        { cell: { width: SM }, money: { currency: '' }, field: 'amount' },
        { cell: { width: SM }, field: 'currency' },
        { cell: { width: MD }, truncate: {}, field: 'source' },
        {
            cell: { width: MD, textAlign: 'right' },
            field: 'attachmentUrls',
            footerAggregate: 'sum',
            renderComponent: Attachments_1.default,
            noSort: true,
        },
    ],
};
